import {SyncedVideoModel} from '../models';
import {PlayTimeRange, SyncedVideoState, TimeRange} from './models';

export function isTimeRangesEqual(range1: readonly TimeRange[], range2: readonly TimeRange[]) {
  if (range1.length !== range2.length)
    return false;
  for (let i = 0; i < range1.length; i++) {
    const value1 = range1[i];
    const value2 = range2[i];
    if (value1.start !== value2.start ||
      value1.end !== value2.end)
      return false;
  }
  return true;
}

function padded(value: number): string {
  let result = value.toString(10);
  return value >= 10
    ? result
    : '0' + result;
}

export function formatTime(seconds: number | null): string {
  if (seconds == null)
    return '--:--';

  if (!isFinite(seconds))
    return '--:--';

  return padded(Math.floor(seconds / 60))
    + ':'
    + padded(Math.floor(seconds % 60));
}

function initialState(model: SyncedVideoModel): SyncedVideoState {
  return {studentIds: []};
}

function initialPlayState(model: SyncedVideoModel): PlayTimeRange {
  return {commandId: -1, start: null, stop: null};
}

class SyncedVideoUtilsClass {
  initialState = initialState;
  initialPlayState = initialPlayState;
}

export const syncedVideoUtils = new SyncedVideoUtilsClass();
